module.exports = __webpack_public_path__ + "static/media/doubleScanKanban.0728cc1d.mp3";